<sol-layout type="vertical" alignX="center" gap="16" pt="64">
  <div class="sol-navbar-header-logo"></div>
  <sol-empty-state [emptyState]="emptyState$()" (action)="onAction()">
    <sol-layout type="vertical" alignX="center" gap="0" class="sol-empty-state-text">
      @for (message of messages$(); track message.text) {
        <div>{{ message | translate }}</div>
      }
      @if (showUsername$()) {
        <sol-layout type="horizontal" gap="8" pt="8" alignY="center">
          <div>{{ username$() }}</div>
          <sol-button [button]="copyButton" (click)="onCopy()" />
        </sol-layout>
      }
    </sol-layout>
  </sol-empty-state>
</sol-layout>
